<script>
const axios = require("@/state/axios.config").default;
import { Money } from "v-money";
import { mapGetters } from "vuex";

export default {
  components: { Money },
  data() {
    return {
      withdraw: {
        amount: 0,
        authcode: null,
        token: null,
      },
      isWithdraw: false,
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "",
        suffix: " VND",
        precision: 0,
        masked: false,
      },
      BalanceRevenue: 0,
      showWarning: false,
    };
  },
  computed: {
    ...mapGetters({
      InfoPayment: "wallet/InfoPayment",
    }),
  },
  methods: {
    async getBalanceRevenue() {
      const balance = await axios.get(`/api/v1/balance-revenue`);
      const { balance_revenue } = balance;
      this.BalanceRevenue = parseFloat(balance_revenue.totalVND);
    },
    CloseWithdraw() {
      this.$emit("closeWithdraw", true);
    },
    async onWithdraw() {
      if (this.isWithdraw) {
        this.$toastr.e(
          "Vui Lòng Đợi Lệnh Rút Trước Đó Được Thực Hiện",
          "Rút thất bại"
        );
      }
      const token = await this.generateCaptChaV3("wallet");
      if (!token) {
        this.$toastr.e("Có lỗi đã xảy ra vui lòng thử lại", "Rút thất bại");
      }
      this.withdraw.token = token;
      this.$store.dispatch("wallet/req_postWithdrawVND", this.withdraw);
    },
  },
  watch: {
    "withdraw.amount": {
      handler() {
        if (this.InfoPayment.min_withdraw_vnd > this.withdraw.amount) {
          this.showWarning = true;
        } else {
          this.showWarning = false;
        }
      },
    },
  },
  created() {
    this.getBalanceRevenue();
    this.unsubscribe = this.$store.subscribe((mutation) => {
      // eslint-disable-next-line default-case
      switch (mutation.type) {
        case "wallet/WITHDRAW_VND_SUCCESS":
          this.withdraw = {
            amount: 0,
            authCode: null,
            token: null,
          };
          this.CloseWithdraw();
          break;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>
<template>
  <b-container>
    <b-form @submit.prevent="onWithdraw">
      <div class="form-group">
        <label for="balance-invest">
          Số tiền trong ví doanh thu
        </label>
        <money
          class="money-amount"
          id="balance-invest"
          v-model="BalanceRevenue"
          v-bind="money"
          step="1"
          readonly
        ></money>
      </div>
      <div class="form-group">
        <label for="amount-invest">
          Số tiền muốn rút
        </label>
        <money
          class="money-amount"
          id="amount-invest"
          v-model="withdraw.amount"
          v-bind="money"
          step="1"
        ></money>
        <p class="fw-medium mt-2 font-size-15 text-center" v-if="showWarning">
          Số tiền tối thiểu bạn có thể rút là:
          {{
            TruncateToDecimals2(parseFloat(InfoPayment.min_withdraw_vnd), "", 0)
          }}
          VND
        </p>
      </div>
      <div class="form-group">
        <label for="auth-invest">
          Mã Bảo Mật
        </label>
        <b-form-input
          id="auth-invest"
          class="money-amount"
          v-model="withdraw.authcode"
          required
        ></b-form-input>
      </div>
      <div
        class="form-group d-flex justify-content-around align-items-center mb-2 mt-4"
      >
        <b-button
          variant="info"
          class="btn-120 btn-gradient-1 my-2 px-3 py-2"
          type="submit"
        >
          Đặt Lệnh Rút
        </b-button>
        <b-button
          variant="info"
          class=" btn-120 btn-gradient-outline-1 my-2 font-size-13 p-2"
          @click="CloseWithdraw"
        >
          Huỷ
        </b-button>
      </div>
    </b-form>
  </b-container>
</template>

<style lang="scss" scoped>
.form-group {
  text-transform: capitalize;
}
</style>
